import React from 'react';

import { isTypeExtensionKey } from 'flow/utils/extension-utils-TW';
import { ExtensionKey } from 'flow/types/EntityKeys';
import SenderAvatar from 'flow/components/tickets/internal-note/SenderAvatar';
import Icon from 'flow/components/ui-components/Icon';

interface Props {
    assigneeKey: ExtensionKey | 'unassigned';
}

const SelectAssigneeAvatar = ({ assigneeKey }: Props) => {
    return isTypeExtensionKey(assigneeKey) ? (
        <SenderAvatar sender={assigneeKey} size="small" />
    ) : (
        <>
            <Icon iconKey="agent_remove" />
        </>
    );
};

export default SelectAssigneeAvatar;
